import { render, staticRenderFns } from "./instr-tmpl.vue?vue&type=template&id=462b875c&"
import script from "./instr-tmpl.vue?vue&type=script&lang=ts&"
export * from "./instr-tmpl.vue?vue&type=script&lang=ts&"
import style0 from "./instr-tmpl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports